import { call, takeEvery, put, select } from 'redux-saga/effects';
import { wrapPageSagaWithErrorHandler } from '../page/sagas';
import dialogActions from './actions';

function* agree({ payload }) {
  const response = yield call(payload.request);
  yield put({ payload: { ...payload, data: response.data }, type: dialogActions.AGREE_SUCCESS });
}

function* sign({ payload }) {
  const response = yield call(payload.request);
  yield put({ payload: { ...payload, data: response.data }, type: dialogActions.SIGN_SUCCESS });
}

function* sendCode({ payload }) {
  const { data, fields } = yield select();
  const fieldId = 'appRequest_customer_mfa';
  const maskedValue = fields[fieldId].lookupValues[data[fieldId]]
    .replace('Email Address ', '')
    .replace('Mobile Number ', '');
  const requestData = {
    appRequest_customer_mfa: `${data[fieldId]}-${maskedValue}`,
  };
  const response = yield call(payload.request(requestData));

  yield put({ payload: { data: response.data }, type: dialogActions.SEND_CODE_SUCCESS });
}

export default [
  takeEvery(dialogActions.AGREE, wrapPageSagaWithErrorHandler(agree)),
  takeEvery(dialogActions.SIGN, wrapPageSagaWithErrorHandler(sign)),
  takeEvery(dialogActions.SEND_CODE, wrapPageSagaWithErrorHandler(sendCode)),
];
